const state = {
    isSupplyInfoDialogOpen: false,
    suppliersInfo: null,
};
export default state;
